export const ScheduleViewTypes = {
    SHIFT_ONLY: 'shiftOnlyView',
    TIMESLOTS_ONLY: 'timeslotsOnlyView',
    DETAILED: 'detailedView',
};